module.exports = __webpack_public_path__ + "img/index-btn-1.f7d1b129.png";